import {Injectable} from '@angular/core';
import {Http, Headers} from '@angular/http'
import {Observable} from 'rxjs/Observable';
import {Settings} from '../settings/base'
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw'

import {User} from '../domain/user'
import {BaseService} from "./base-service";


@Injectable()
export class AuthService extends BaseService {
  currentUser: User;
  response: any = null
  error: any = null

  constructor(private _http: Http, private _settings: Settings) {
    super();
  }

  public login(credentials) {
    if (credentials.username === null || credentials.password === null) {
      return Observable.throw("Please insert credentials");
    } else {
      return Observable.create(observer => {
        // At this point make a request to your backend to make a real check!
        let data = {
          username: credentials.username,
          password: credentials.password
        };

        let options = this.createHeaders("Credentials", data);

        let _res: any = null;
        _res = this._http.post(this._settings.base_url + "auth/", data,
                               options).map(res => res.json());

        _res.subscribe(
          data => {
            if (data[0].pk !== undefined){
               localStorage.setItem("doctor_id", data[0].pk)
            }
            observer.next(true);
            observer.complete();
          },
          error=>{
            observer.error(error.json().detail || 'Server error');
            observer.complete();
          }
        );

      });
    }
  }

  public register(registration_data) {
    // At this point store the credentials to your backend!
    return Observable.create(observer => {

      let user_data = {
        username: registration_data.username,
        first_name: registration_data.first_name,
        last_name: registration_data.surname,
        email: registration_data.email,
        password: registration_data.password
      };


      let options = this.createHeaders("Authorization");
      let _res: any = null;
      _res = this._http.post(
             this._settings.base_url + "users/",
             user_data,
             options).map(res => res.json());

      _res.subscribe(user => {
        console.log(user)
        let doctor_data = {
        user:user.id,
        phone_number: registration_data.phone_number,
        title: registration_data.title
      };

        let _doc_res = this._http.post(this._settings.base_url + "doctors/", doctor_data, options).map(res => res.json());

         _doc_res.subscribe(doctor => {
            observer.next(true);
            observer.complete();
         }, error => {
          let errors:string="";
           for (var err in error.json()){
             let field = err
             errors=errors+field+" "+error.json()[field]+"<br> "
            }
           observer.error(errors);
           observer.complete();
        });
        }, error => {
          let errors:string="";
           for (var err in error.json()){
             let field = err
             errors=errors+field+" "+error.json()[field]+"<br> "
            }
           observer.error(errors);
           observer.complete();
        });
    });

  }

  public getUserInfo(): User {
    return this.currentUser;
  }

  public logout() {
    return Observable.create(observer => {
      this.currentUser = null;
      observer.next(true);
      observer.complete();
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/auth-service.ts